/* BetterBone LP — Hero buy-box logic (SIZE-leading)
 * Self-contained, defensive, multi-instance safe.
 * Reads three <script class="bb-variant-data" data-size="LARGE|SMALL|MINI"> JSON blobs
 * inside each section root [data-section-id]; each blob's variants carry {density, flavor}.
 * Wires size cards -> density pills -> flavor pills, quantity stepper, gallery image swap,
 * and add-to-cart against the theme's ajax cart.
 */
(function () {
  'use strict';

  var SIZES = ['LARGE', 'SMALL', 'MINI'];
  var DENSITY_ORDER = ['Light', 'Moderate', 'Hard'];
  var FLAVOR_ORDER = ['Veggie', 'Beef', 'Venison'];
  var SIZE_LABEL = { LARGE: 'Large', SMALL: 'Small', MINI: 'Mini' };

  function money(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    return '$' + (n / 100).toFixed(2);
  }

  function parseData(root) {
    var blobs = root.querySelectorAll('.bb-variant-data');
    var data = {};
    for (var i = 0; i < blobs.length; i++) {
      var size = (blobs[i].getAttribute('data-size') || '').toUpperCase();
      if (!size) continue;
      try {
        var parsed = JSON.parse(blobs[i].textContent.trim());
        if (parsed && Array.isArray(parsed.variants)) {
          data[size] = parsed;
        }
      } catch (e) {
        /* malformed blob — skip */
      }
    }
    return data;
  }

  function uniqueOrdered(values, order) {
    var seen = {};
    var out = [];
    for (var i = 0; i < order.length; i++) {
      if (values.indexOf(order[i]) !== -1) { out.push(order[i]); seen[order[i]] = 1; }
    }
    for (var j = 0; j < values.length; j++) {
      if (!seen[values[j]]) { out.push(values[j]); seen[values[j]] = 1; }
    }
    return out;
  }

  function BuyBox(root) {
    this.root = root;
    this.data = parseData(root);
    this.sizes = SIZES.filter(function (s) { return !!this.data[s]; }, this);
    if (!this.sizes.length) return; // nothing to wire

    this.size = this.data.LARGE ? 'LARGE' : this.sizes[0];
    this.density = 'Moderate';
    this.flavor = 'Veggie';
    this.qty = 1;
    this.variant = null;

    // cache nodes
    this.els = {
      title: root.querySelector('[data-bb-title]'),
      price: root.querySelector('[data-bb-price]'),
      sizeCards: root.querySelector('[data-bb-size-cards]'),
      densityWrap: root.querySelector('[data-bb-density-options]'),
      flavorWrap: root.querySelector('[data-bb-flavor-options]'),
      mainImg: root.querySelector('[data-bb-main-image]'),
      qtyVal: root.querySelector('[data-bb-qty-value]'),
      qtyMinus: root.querySelector('[data-bb-qty-minus]'),
      qtyPlus: root.querySelector('[data-bb-qty-plus]'),
      atc: root.querySelector('[data-bb-atc]'),
      atcLabel: root.querySelector('[data-bb-atc-label]')
    };

    this.bind();
    this.render();
  }

  BuyBox.prototype.product = function () {
    return this.data[this.size] || null;
  };

  // variants for the current size product (each carries density + flavor)
  BuyBox.prototype.variants = function () {
    var p = this.product();
    return p ? p.variants : [];
  };

  BuyBox.prototype.densitiesForFlavor = function (flavor) {
    var vs = this.variants();
    var out = [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].flavor === flavor && out.indexOf(vs[i].density) === -1) out.push(vs[i].density);
    }
    return uniqueOrdered(out, DENSITY_ORDER);
  };

  BuyBox.prototype.allDensities = function () {
    var vs = this.variants();
    var out = [];
    for (var i = 0; i < vs.length; i++) {
      if (out.indexOf(vs[i].density) === -1) out.push(vs[i].density);
    }
    return uniqueOrdered(out, DENSITY_ORDER);
  };

  BuyBox.prototype.flavorsForDensity = function (density) {
    var vs = this.variants();
    var out = [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].density === density && out.indexOf(vs[i].flavor) === -1) out.push(vs[i].flavor);
    }
    return uniqueOrdered(out, FLAVOR_ORDER);
  };

  BuyBox.prototype.allFlavors = function () {
    var vs = this.variants();
    var out = [];
    for (var i = 0; i < vs.length; i++) {
      if (out.indexOf(vs[i].flavor) === -1) out.push(vs[i].flavor);
    }
    return uniqueOrdered(out, FLAVOR_ORDER);
  };

  BuyBox.prototype.findVariant = function (density, flavor) {
    var vs = this.variants();
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].density === density && vs[i].flavor === flavor) return vs[i];
    }
    return null;
  };

  // Repair the current density/flavor selection so a valid combo always exists in this size.
  BuyBox.prototype.repairSelection = function () {
    var densities = this.allDensities();
    var flavors = this.allFlavors();
    if (densities.indexOf(this.density) === -1) this.density = densities[0];
    if (flavors.indexOf(this.flavor) === -1) this.flavor = flavors[0];

    if (!this.findVariant(this.density, this.flavor)) {
      var fForD = this.flavorsForDensity(this.density);
      if (fForD.length && fForD.indexOf(this.flavor) === -1) this.flavor = fForD[0];
    }
    if (!this.findVariant(this.density, this.flavor)) {
      var dForF = this.densitiesForFlavor(this.flavor);
      if (dForF.length) this.density = dForF[0];
    }
  };

  BuyBox.prototype.bind = function () {
    var self = this;

    if (this.els.sizeCards) {
      this.els.sizeCards.addEventListener('click', function (e) {
        var card = e.target.closest('[data-bb-size]');
        if (!card || !self.els.sizeCards.contains(card)) return;
        var s = (card.getAttribute('data-bb-size') || '').toUpperCase();
        if (!self.data[s] || s === self.size) return;
        self.size = s;
        self.repairSelection();
        self.render();
      });
    }

    if (this.els.densityWrap) {
      this.els.densityWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bb-density]');
        if (!btn || !self.els.densityWrap.contains(btn)) return;
        var d = btn.getAttribute('data-bb-density');
        if (d === self.density) return;
        self.density = d;
        if (!self.findVariant(self.density, self.flavor)) {
          var fs = self.flavorsForDensity(self.density);
          if (fs.length) self.flavor = fs[0];
        }
        self.render();
      });
    }

    if (this.els.flavorWrap) {
      this.els.flavorWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bb-flavor]');
        if (!btn || !self.els.flavorWrap.contains(btn)) return;
        var flavor = btn.getAttribute('data-bb-flavor');
        if (flavor === self.flavor) return;
        self.flavor = flavor;
        if (!self.findVariant(self.density, self.flavor)) {
          var ds = self.densitiesForFlavor(self.flavor);
          if (ds.length) self.density = ds[0];
        }
        self.render();
      });
    }

    if (this.els.qtyMinus) {
      this.els.qtyMinus.addEventListener('click', function () {
        self.qty = Math.max(1, self.qty - 1);
        self.renderQty();
      });
    }
    if (this.els.qtyPlus) {
      this.els.qtyPlus.addEventListener('click', function () {
        self.qty = self.qty + 1;
        self.renderQty();
      });
    }
    if (this.els.qtyVal && this.els.qtyVal.tagName === 'INPUT') {
      this.els.qtyVal.addEventListener('change', function () {
        var n = parseInt(self.els.qtyVal.value, 10);
        self.qty = isFinite(n) && n >= 1 ? n : 1;
        self.renderQty();
      });
    }

    if (this.els.atc) {
      this.els.atc.addEventListener('click', function (e) {
        e.preventDefault();
        self.addToCart();
      });
    }
  };

  BuyBox.prototype.numericId = function (variant) {
    if (!variant || variant.id == null) return null;
    var id = String(variant.id);
    var m = id.match(/(\d+)\s*$/); // handles gid://shopify/ProductVariant/123
    return m ? m[1] : id;
  };

  BuyBox.prototype.buildOptionButtons = function (wrap, values, current, allValues, type, subLabels) {
    if (!wrap) return;
    wrap.innerHTML = '';
    var list = allValues || values;
    for (var i = 0; i < list.length; i++) {
      var val = list[i];
      var available = values.indexOf(val) !== -1;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bb-pill';
      btn.setAttribute('data-bb-' + type, val);
      if (val === current) btn.classList.add('is-selected');
      if (!available) { btn.classList.add('is-unavailable'); btn.disabled = true; }
      var label = document.createElement('span');
      label.className = 'bb-pill__label';
      label.textContent = val;
      btn.appendChild(label);
      if (subLabels && subLabels[val]) {
        var sub = document.createElement('span');
        sub.className = 'bb-pill__sub';
        sub.textContent = subLabels[val];
        btn.appendChild(sub);
      }
      wrap.appendChild(btn);
    }
  };

  BuyBox.prototype.render = function () {
    this.repairSelection();
    this.variant = this.findVariant(this.density, this.flavor);

    // size cards active state
    if (this.els.sizeCards) {
      var cards = this.els.sizeCards.querySelectorAll('[data-bb-size]');
      for (var i = 0; i < cards.length; i++) {
        var s = (cards[i].getAttribute('data-bb-size') || '').toUpperCase();
        cards[i].classList.toggle('is-selected', s === this.size);
      }
    }

    // density pills — show all densities in this size; disable those without the current flavor
    this.buildOptionButtons(
      this.els.densityWrap,
      this.densitiesForFlavor(this.flavor),
      this.density,
      this.allDensities(),
      'density',
      null
    );

    // flavor pills — show all flavors in this size; disable those not in the current density
    this.buildOptionButtons(
      this.els.flavorWrap,
      this.flavorsForDensity(this.density),
      this.flavor,
      this.allFlavors(),
      'flavor',
      null
    );

    // title
    if (this.els.title) {
      this.els.title.textContent = 'BetterBone ' + (SIZE_LABEL[this.size] || this.size) + ' Chew Toy';
    }

    // price + image + availability
    var v = this.variant;
    if (this.els.price) {
      this.els.price.textContent = v ? (v.priceMoney || money(v.price)) : '';
    }
    if (this.els.mainImg && v && v.image) {
      this.els.mainImg.src = v.image;
      this.els.mainImg.alt = 'BetterBone ' + (SIZE_LABEL[this.size] || this.size) + ' Chew Toy';
    } else if (this.els.mainImg) {
      var p = this.product();
      if (p && p.image) this.els.mainImg.src = p.image;
    }

    this.renderQty();
    this.renderAvailability();
  };

  BuyBox.prototype.renderQty = function () {
    if (!this.els.qtyVal) return;
    if (this.els.qtyVal.tagName === 'INPUT') this.els.qtyVal.value = this.qty;
    else this.els.qtyVal.textContent = this.qty;
  };

  BuyBox.prototype.renderAvailability = function () {
    if (!this.els.atc) return;
    var available = !!(this.variant && this.variant.available);
    this.els.atc.disabled = !available;
    this.els.atc.classList.toggle('is-soldout', !available);
    if (this.els.atcLabel) {
      this.els.atcLabel.textContent = available ? 'ADD TO CART' : 'Sold Out';
    }
  };

  BuyBox.prototype.openCartDrawer = function () {
    try {
      var PXU = window.PXUTheme;
      if (PXU && PXU.jsAjaxCart && typeof PXU.jsAjaxCart.showDrawer === 'function') {
        if (typeof PXU.jsAjaxCart.updateView === 'function') PXU.jsAjaxCart.updateView();
        PXU.jsAjaxCart.showDrawer();
        if (PXU.jsCart && typeof PXU.jsCart.updateView === 'function') PXU.jsCart.updateView();
        return true;
      }
    } catch (e) { /* fall through */ }
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    } catch (e2) { /* ignore */ }
    return false;
  };

  BuyBox.prototype.addToCart = function () {
    var self = this;
    var v = this.variant;
    if (!v || !v.available) { this.renderAvailability(); return; }
    var id = this.numericId(v);
    if (!id) return;

    var btn = this.els.atc;
    if (btn) btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: this.qty })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed ' + res.status);
        return res.json();
      })
      .then(function () {
        if (btn) btn.classList.remove('is-loading');
        var opened = self.openCartDrawer();
        if (!opened) {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        if (btn) btn.classList.remove('is-loading');
        window.location.href = '/cart';
      });
  };

  function init() {
    var roots = document.querySelectorAll('.bb-lp-hero[data-section-id]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__bbInit) continue;
      roots[i].__bbInit = true;
      try { new BuyBox(roots[i]); } catch (e) { /* keep other instances alive */ }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
